module.exports = __webpack_public_path__ + "img/banner04_info_pic5.21c4fb28.jpg";